module.exports = "<p>\n  subpage-observacion-y-reflexion-en-la-escuela-infantil works!\n</p>\n"